import { useCallback } from 'react';

import { TypedDocumentNode, useApolloClient } from '@apollo/client';

type PrefetchHookOptions = {
  name: string;
  fetchPolicy?: 'cache-first' | 'cache-only' | 'network-only' | 'no-cache';
};

type PrefetchHook<TVariables> = (name: string, vars?: TVariables) => void;

export function withStandardPrefetchHook<
  TData,
  TVariables extends { name: string },
>(
  query: TypedDocumentNode<TData, TVariables>,
  queryOptions?: Pick<PrefetchHookOptions, 'fetchPolicy'>,
) {
  return (): PrefetchHook<Omit<TVariables, 'name'>> => {
    const client = useApolloClient();

    const prefetch = useCallback(
      (name: string, vars?: TVariables) => {
        client.query<TData, TVariables>({
          query,
          variables: { name, ...vars } as TVariables,
          fetchPolicy: queryOptions?.fetchPolicy ?? 'cache-first',
        });
      },
      [client],
    );

    return prefetch as PrefetchHook<Omit<TVariables, 'name'>>;
  };
}
